import { useCallback, useEffect, useState } from "react";
import { useService } from "../../../../hooks";

export const useRecentPosts = () => {
  const { fetchByAttr } = useService("Data", "post");
  const [postList, setpostList] = useState([]);
  const [newLength, setnewLength] = useState<number>(0);
  const getPostsData = useCallback(async () => {
    const result = await fetchByAttr({ status: "publish" });
    if (result.status) {
      setpostList(result.data);
      setnewLength(result.data?.length);
    }
  }, []);
  useEffect(() => {
    getPostsData();
  }, []);
  return {
    postList,
    newLength,
  };
};
